import { render } from "./Headline.vue?vue&type=template&id=05b6ced3&scoped=true&ts=true"
import script from "./Headline.vue?vue&type=script&lang=ts"
export * from "./Headline.vue?vue&type=script&lang=ts"

import "./Headline.vue?vue&type=style&index=0&id=05b6ced3&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b6ced3"]])

export default __exports__